
require('crypto-js/md5');
module.exports = require('crypto-js/core');
